import type { UserPropertyMultiEditRequestWebDto } from '@zg-rentals/ts-rental-manager-api-beta-client';

export const getDataToSave = ({
  inputs,
  categorizedAmenitiesKeys,
  listingAlias,
  fieldName,
  valueToSave,
}: {
  inputs: Record<string, boolean | string>;
  categorizedAmenitiesKeys: Record<string, Array<string>>;
  listingAlias: string;
  fieldName?: string;
  valueToSave?: string | boolean;
}): UserPropertyMultiEditRequestWebDto => {
  const property = Object.keys(inputs).reduce(
    (a: Record<string, boolean | string>, key) => {
      if (categorizedAmenitiesKeys[key]) {
        categorizedAmenitiesKeys[key].forEach((unique) => (a[unique] = unique === inputs[key]));
      } else {
        a[key] = inputs[key];
      }

      return a;
    },
    { listingAlias },
  );

  if (fieldName) {
    /**
     * if `fieldName` is a `category`, then `valueToSave` is an `apiKeyValue` of such `category`,
     * else `fieldName` is `apiKey` and `valueToSave` is `boolean`
     */
    if (categorizedAmenitiesKeys[fieldName]) {
      categorizedAmenitiesKeys[fieldName].forEach((categoryKey) => (property[categoryKey] = false));
      property[valueToSave as string] = true;
    } else {
      property[fieldName] = valueToSave as boolean;
    }
  }

  return {
    property: {
      ...property,
      listingAlias,
    },
  };
};
